// 规则变体配置。默认值 = 国家体育总局棋牌运动管理中心审定《竞技掼蛋竞赛规则（试行）》（下称“竞赛规则”）；
// 民间与平台常见变体做成开关。改规则先改游戏 docs/规则配置.md 再抄进来，并补测试。

export interface Ruleset {
  /** 上游搭档名次 → 升几级（竞赛规则 第二条 12）。 */
  upgrade: { 2: number; 3: number; 4: number };
  passA: {
    /** 打自己的 A 时，上游搭档是这些名次才算过 A（第二条 13：搭档不是下游）。 */
    allowedPartnerPlaces: number[];
    /** 打 A 连续失败几次退回 2；0 = 不退（竞赛规则无此条，民间变体）。 */
    resetAfterFails: number;
  };
  tribute: {
    /** 还牌点数上限（第十条：不超过 10；全手牌都大于 10 则还最小的牌）。 */
    returnMaxRank: number;
    /** 下游或双下方抓到两个大王即抗贡（第十条 四）。 */
    resistWithTwoBigJokers: boolean;
  };
  /**
   * 首副牌谁先出：flip = 竞赛规则第七条，翻一张牌（王或红桃 2 重翻），抓到这张牌的人首圈领出；
   * random = 随机一家；seat0 = 固定 0 号。
   */
  firstLead: 'flip' | 'random' | 'seat0';
  /** 报牌：剩余不超过几张时公开张数（第十一条：10 张）；0 = 始终公开（民间网页常见）。 */
  announceAt: number;
  /**
   * 限副赛（第十二条“规定副数内级数高者胜”）：打满几副就结束；0 = 不限，打到过 A 为止。
   * 级数相同时由最后一副拿上游的一方胜——竞赛规则未写，暂定，待作者定。
   */
  roundLimit: number;
  /**
   * 目标级（作者 11-03 参考“目标 过6”）：打到自己的目标级、这一副拿上游且搭档不是末游即赢——和过 A 同一条规则（第十二条），
   * 只是终点从 A 提前；升级封顶到目标级。14 = A（默认，打到过 A）。
   */
  target: number;
}

export const RULES: Ruleset = {
  upgrade: { 2: 3, 3: 2, 4: 1 },
  passA: { allowedPartnerPlaces: [2, 3], resetAfterFails: 0 },
  tribute: { returnMaxRank: 10, resistWithTwoBigJokers: true },
  firstLead: 'flip',
  announceAt: 10,
  roundLimit: 0,
  target: 14,
};

/**
 * 赛制编号 → 规则（单机与联机服务端共用，保证两边判法一致）：
 * 0 = 打到过 A；8 / 12 = 限 8 / 12 副（到时比级数）；-6 / -10 = 打到过 6 / 过 10。
 */
export const MATCH_MODES = [0, -10, -6, 8, 12] as const;
export function rulesFor(mode: number, base: Ruleset = RULES): Ruleset {
  if (!MATCH_MODES.includes(mode as (typeof MATCH_MODES)[number])) mode = 0;
  return mode > 0 ? { ...base, roundLimit: mode, target: 14 } : { ...base, roundLimit: 0, target: mode < 0 ? -mode : 14 };
}
